import React from 'react';

import {BADGE_DIMENSIONS} from '../constants';
import type {BoneProps} from '../types';

import {Bone} from './Bone';

type BoneBadgeProps = Omit<BoneProps, 'width' | 'height' | 'borderRadius'> & {
  width?: number;
  height?: number;
};

export const BoneBadge: React.FC<BoneBadgeProps> = React.memo(
  ({width = BADGE_DIMENSIONS.width, height = BADGE_DIMENSIONS.height, ...rest}) => (
    <Bone width={width} height={height} borderRadius={BADGE_DIMENSIONS.borderRadius} {...rest} />
  ),
);
BoneBadge.displayName = 'BoneBadge';
